import React, { useState, Suspense } from "react";
import { Route, Routes } from 'react-router-dom';
import './App.css';
import ParkingList from './parkings/ParkingList';
import MainNavigation from './components/layout/MainNavigation';
import Home from './components/layout/Home';
import Help from './components/layout/Help';
import ParkingDetails from './parkings/ParkingDetails';
import DetectorsByParkingTable from './detectors/DetectorsByParkingTable';
import DetectorsSleepAndAck from './detectors/DetectorsSleepAndAck';
import ParkingStats from './parkings/ParkingStats';
import ParkingErrors from "./parkings/ParkingErrors";
import LedTables from "./services/ledTables";
import LedTableNew from "./services/ledTableNew";
import HistoryChart from './components/charts/HistoryChart';
import Register from "./components/Register";
import ParkingNew from "./parkings/ParkingNew";
import "bootstrap/dist/css/bootstrap.min.css";

import LocaleContext from "./LocaleContext";

import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from './components/Loading';

import i18n from './i18n';

function App() {

  const [locale, setLocale] = useState(i18n.language);

  i18n.on('languageChanged', (lng) => setLocale(i18n.language));

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
    <Suspense fallback={<Loading />}>
    <div>
    <MainNavigation/>
    <Routes>
    <Route path='/' element={<Home/>}/>
    <Route path='/parkingDetails/:parkingID' element={<ParkingDetails/>}/>
    <Route path='/detectorsTable/:parkingID' element={<DetectorsByParkingTable/>}/>
    <Route path='/sleepAndAck/:addressMin/:addressMax' element={<DetectorsSleepAndAck/>}/>
    <Route path='/parkingStats/:parkingID' element={<ParkingStats/>}/>
    <Route path='/parkings' element={<ParkingList/>}/>
    <Route path='/Help' element={<Help/>}/>
    <Route path="/register" element={<Register/>} />
    <Route path='/detectorDetails/:parkingID/:address' element={<HistoryChart/>}/>
    <Route path='/ledTables/:userID' element={<LedTables />} />
    <Route path='/parkingErrors' element={<ParkingErrors />} />
    <Route path='/parkingNew' element={<ParkingNew />} />
    <Route path='/ledTableNew' element={<LedTableNew />} />
    </Routes>
    </div>
    </Suspense>
    </LocaleContext.Provider>
  );
}

export default App;
